import { defineStore } from 'pinia';

export const useRuntimeStore = defineStore('runtime-store', {
  state: () => ({
    // 关于元素的渲染尺寸
    stateMap: {} as Record<string, RuntimeState>,

    // // 关于数据源-正在使用的
    configData: {} as Record<string, string | number>,

    // 关于数据源-全部数据源
    configDataWhole: {} as Record<string, string | number>,
    configDataDefault: {} as Record<string, string | number>,
    watchfaceAst: {} as Ast
  }),
  getters: {
    shapeState(state) {
      return (shapeId: string) => {
        return Object.values(state.stateMap).find((item) => {
          const _id = String(item?._id ?? '');
          return _id.split(',')?.some?.((item) => item == shapeId);
        });
      };
    }
  },
  actions: {
    async reset(data: {
      stateMap: Record<string, RuntimeState>;
      configData: Record<string, string | number>;
      configDataWhole: Record<string, string | number>;
      watchfaceAst: Ast;
    }) {
      const { stateMap, configDataWhole, watchfaceAst, configData } = data;
      this.stateMap = stateMap;
      this.configData = configData;
      this.configDataWhole = configDataWhole;
      if (!Object.keys(this.configDataDefault).length) {
        this.configDataDefault = { ...this.configDataWhole };
      }
      this.watchfaceAst = watchfaceAst;
    }
  }
});
